const isValidEmail = (email: string) => {
  const validPattern =
    /^[a-zA-Z0-9.+_-]+@\b((?=[a-zA-Z0-9-]{1,63}\.)[a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,63}\b$/;
  return validPattern.test(email);
};

export { isValidEmail };
